export default __webpack_public_path__ + "static/media/checkmark.f4985feb.svg";